import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

export interface Breadcrumb {
  id: number | null;
  title: string;
  path?: string;
}

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
})
export class BreadcrumbsComponent {
  @Input() items: Breadcrumb[] = [];

  @Output() itemClick: EventEmitter<number> = new EventEmitter<number>();

  constructor(private router: Router) {}

  onClick({ id, path }: Breadcrumb): void {
    if (path) {
      this.router.navigateByUrl(path);
      return;
    }

    if (id) {
      this.itemClick.emit(id);
      return;
    }
  }
}
